module.exports = __webpack_public_path__ + "img/logo.36166adfacf0c8cc11d493f2161164fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 108
// module chunks = 0